const escape = (func, id) => {
    if (!id) {
        document.addEventListener("keyup", (event) => {
            if (event.code == "Escape") {
                func()
            }
        })
    } else {
        document.getElementById(id).addEventListener("keyup", (event) => {
            if (event.code == "Escape") {
                func()
            }
        })
    }
}


const Keyboard = {
    escape
}

export default Keyboard